export type ReportsState = {
  reports: any[];
};

export type ReportsActions = {
  setReports: (reports: any[]) => void;
};

export const createReportsSlice = (
  set,
  get
): ReportsState & ReportsActions => ({
  reports: [],
  setReports: (reports) => set({ reports }),
});
